export default "__VITE_ASSET__BwYS13n6__"